export default __webpack_public_path__ + "static/media/motorbike_driver.932b544a.png";